import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { AddNewStakeholderButton, StakeholdersTable } from './stakeholders';
import { AddNewUserButton, UsersTable } from './users';
import { CardTabOptions, SonarCardTabs, ViewArea } from '@ui/general';

const tabs: Array<CardTabOptions> = [
	{
		children: <UsersTable />,
		extra: <AddNewUserButton />,
		key: 'users',
		label: COPY_SPECIFIC.AROVY_USERS
	},
	{
		children: <StakeholdersTable />,
		extra: <AddNewStakeholderButton />,
		key: 'stakeholders',
		label: COPY_SPECIFIC.STAKEHOLDERS
	}
];

export const TeamView: React.FC = () =>
	<ViewArea
		fullWidth
		id='team-view'>
		<SonarCardTabs
			items={ tabs }
			title={ COPY_SPECIFIC.TEAM } />
	</ViewArea>;

